import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useOwnerFindAllQuery } from 'store';
import Detail from './Detail'
import ownerSvg from '../../assets/images/svg/owner.svg'
import Create from './Create';


const OwnerIndex = (props: any) => {
  const [ownerList, setOwnerList] = useState<any>();
  const [ownerOne, setOwnerOne] = useState<any>(null);
  const [newOwnerLoad, setNewOwnerLoad] = useState<boolean>(false);


  const {
    data: ownerData,
    error: ownerDataError,
    isFetching: isOwnerDataFetching,
  } = useOwnerFindAllQuery(`?table_name=${props?.table_name}&connection_id=${props?.id}`);

  useEffect(() => {
    setOwnerList(ownerData?.data)
  }, [props?.id, props?.table_name, ownerData, ownerList, newOwnerLoad])

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={ownerSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {ownerList?.length}
                  </span>
                </li>
              </ul>
            </div>
            <button
              type="button"
              disabled={newOwnerLoad}
              onClick={() => {
                setNewOwnerLoad(true)
              }}
              className="btn btn-success  btn-label"
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
            </button>
          </div>
        </Col>
      </Row>
      <Row >
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {ownerList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setNewOwnerLoad(false)
                            setOwnerOne(item);
                          }}
                        >
                          {item?.owner_description}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        {newOwnerLoad === false
          ?
          <Detail data={ownerOne} id={props?.id} table_name={props?.table_name} newOwnerLoad={newOwnerLoad} />
          :
          <Create id={props?.id} table_name={props?.table_name}/>
        }
      </Row>
    </React.Fragment>
  );
}

export default OwnerIndex;